import styled from '@emotion/styled';
import { breakpoints, spacing } from '@naf/theme';
import { Top, Wrapper, Content } from '../Styles';

export const StyledWrapper = styled(Wrapper)`
  padding: ${spacing.space80} ${spacing.space40};
  @media (max-width: ${breakpoints.m}) {
    padding: ${spacing.space40} 0;
  }
`;

export const StyledContent = styled(Content)`
  display: flex;
  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    padding: 0;
    max-width: 100vw;
  }
`;

export const Left = styled(Top)`
  align-items: start;
  width: fit-content;
  max-width: 45%;
  padding-right: ${spacing.space80};

  @media (max-width: ${breakpoints.l}) {
    padding-right: ${spacing.space32};
  }
  @media (max-width: ${breakpoints.m}) {
    width: unset;
    max-width: unset;
    padding: 0 ${spacing.space24};
  }
`;

export const Right = styled.div`
  max-width: 45%;
  @media (max-width: ${breakpoints.m}) {
    width: 100%;
    max-width: unset;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    gap: ${spacing.space8};
    flex-direction: row;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;

    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */

    & > div:first-child {
      margin-left: ${spacing.space24};
    }

    & > div:last-child {
      margin-right: ${spacing.space24};
    }
  }
`;

export const ButtonGroupMargin = styled.div`
  margin-top: ${spacing.space40};
`;

export const TagWrapper = styled.div`
  margin-bottom: ${spacing.space8};
`;
